Vue.component('cardTypes', {
  template: templates.cardTypes,
  data() {
    return {
      model: {
        edit: false,
        type: {
          id: null,
          name: null,
          active: false
        },
        types: {}
      }
    }
  },
  mounted() {
    const c = this;
    c.get();
  },
  methods: {
    get() {
      const c = this;
      let data = {};

      typeService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.types = data;
          c.$root.$emit('types', data);
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    edit(id) {
      const c = this;
      let data = c.model.types[`${id}`];

      if (id == c.model.type.id) {
        c.model.edit = false;
      } else {
        c.model.edit = true;
      }

      c.model.type = {
        id: id,
        name: data.name,
        active: data.active
      }
    },
    add() {
      const c = this;
      c.model.edit = true;
    },
    save() {
      const c = this;

      const data = c.model.type;

      if (!data.name) {
        utils.alert.error('Name is required');
        return;
      }
      
      typeService.get(data)
        .then(function (response) {

          if (data.id) {
            c.model.types[`${data.id}`] = data;
          } else {
            data.id = response.data.id;
            c.model.types[`${data.id}`] = data;
          }

          c.reset();
          
          utils.alert.success('Saved!');
          
        })
        .catch(function (error) {
          utils.alert.error('Failed to save.');
        });
    },
    reset() {
      const c = this;
      c.model.edit = false;
      
      c.model.type = {
        id: null,
        name: null,
        active: false
      }
    }
  }
});